import { NUMBER_INPUT_REGEX } from 'src/constants/regex';
import { ChangeEvent } from 'react';
import { useAppTranslation } from 'src/i18n/hooks';

interface Props {
  onClickMax?: () => void;
  value: string;
  onChange?: (val: string) => void;
  errorMessage?: string;
  disabled?: boolean;
}

const TokenInput = ({ onClickMax, value, onChange, errorMessage, disabled }: Props) => {
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (NUMBER_INPUT_REGEX.test(value) || !value) {
      onChange?.(e.target.value);
    }
  };

  const { t } = useAppTranslation('trade');

  return (
    <div className="flex flex-col  w-full">
      <div className="flex flex-col gap-[4px] border-[#494950] border-[1px] rounded-[8px] px-[1.25rem] py-[0.75rem] w-full">
        <div className="flex gap-[8px]">
          <input
            disabled={disabled}
            value={value}
            onChange={handleInputChange}
            placeholder="0.00"
            className="flex-1 bg-[transparent] outline-none border-none text-[16px] w-[100%]"
          />
          {!disabled && <button onClick={onClickMax}>{t('depositModal.max')}</button>}
        </div>
      </div>
      {errorMessage && <span className="text-[12px] text-[red]">{errorMessage}</span>}
    </div>
  );
};

export default TokenInput;
